import React from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import OurServices from '../components/Services';
import NavBar from '../components/Navbar/NavBar';


const Home = () => {
    return (
        <>
        <NavBar/>
            <Hero />
            <Intro />
            <OurServices />
            <Clients />
          
            <Footer />
        </>

    )
}

export default Home;

